// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'
import echarts from 'echarts'
import 'video.js/dist/video-js.css'
import axios from 'axios' // 本地JSON
import VueAxios from 'vue-axios' // 本地JSON
import MyEchartsMapUI from './components/echartsmap'
import MyNavUI from './components/nav'
import moment from 'moment'


Vue.filter('time', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD'
  return moment(value).format(formatString)
})

// axios.defaults.baseURL = process.env.API_ROOT
// Vue.prototype.jsonUrl = 'http://127.0.0.1:8080/'

// 请求头添加token
axios.interceptors.request.use(config => {
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})


axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error == 'Error: Request failed with status code 401') {
      window.sessionStorage.removeItem('token')
      router.push({
        path: '/login'
      })
      return Promise.reject(error)
    }
    return Promise.reject(error)
  })
//   Number.prototype.toFixed=function (d) { 
//     var s=this+""; 
//     if(!d)d=0; 
//     if(s.indexOf(".")==-1)s+="."; 
//     s+=new Array(d+1).join("0"); 
//     if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0,"+(d+1)+"})?)\\d*$").test(s)){
//         var s="0"+RegExp.$2,pm=RegExp.$1,a=RegExp.$3.length,b=true;
//         if(a==d+2){
//             a=s.match(/\d/g); 
//             if(parseInt(a[a.length-1])>4){
//                 for(var i=a.length-2;i>=0;i--){
//                     a[i]=parseInt(a[i])+1;
//                     if(a[i]==10){
//                         a[i]=0;
//                         b=i!=1;
//                     }else break;
//                 }
//             }
//             s=a.join("").replace(new RegExp("(\\d+)(\\d{"+d+"})\\d$"),"$1.$2");

//         }if(b)s=s.substr(1); 
//         return (pm+s).replace(/\.$/,"");
//     }return this+"";

// };
// Vue.prototype.$http = axios
Vue.use(MyEchartsMapUI)
Vue.use(MyNavUI)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios, axios)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'pGpYBwHuXKvW3yFF6b7kWEw7fGugfusG'
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js